import { getLocalStorage } from '../../utils/utils';
import { Navigate, Outlet } from 'react-router-dom';

export const Outer = () => {
  const token = getLocalStorage('token');
  const role = getLocalStorage('role');

  if (token === null || role === null) {
    return <Outlet />;
  } else {
    return <Navigate to="/dashboard" />;
  }
};
